import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBoldDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 15,
	viewBox: "0 0 12 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.7417 7.42925C11.6929 7.3965 11.4908 7.29884 11.4479 7.29884H8.65627V0.525312C8.65627 0.508513 8.65533 0.491999 8.65345 0.47577V0.450715H8.6497C8.60966 0.196173 8.37003 0 8.0791 0H3.9229C3.63197 0 3.39235 0.195889 3.3523 0.450715H3.34574V7.29913H0.551575C0.508717 7.29913 0.306632 7.39679 0.257831 7.42953C-0.0243379 7.61802 -0.0740772 7.97762 0.104546 8.24611L5.43885 14.7292C5.55303 14.8591 5.67848 14.9339 5.84365 15H6.15585L6.37233 14.8986C8.27337 12.7293 10.0371 10.4504 11.8953 8.24611C12.0739 7.97734 12.0242 7.61802 11.742 7.42953L11.7417 7.42925Z",
		fill: "currentColor"
	})
});
export default SvgArrowBoldDown;
